/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { DocumentType } from '../../../core/models/DocumentType';
import { ExternalDocumentation } from '../../../core/models/common/ExternalDocumentation';
import { Info } from '../../../core/models/common/Info';
import { Tag } from '../../../core/models/common/Tag';
import { OasDocument } from '../../models/OasDocument';
import { OasPaths } from '../../models/OasPaths';
import { OasSecurityRequirement } from '../../models/OasSecurityRequirement';

/**
 * Models the root document of the OpenAPI 2.0 (aka Swagger) data model.
 * @author eric.wittmann@gmail.com
 * @class
 * @extends OasDocument
 */
export class Oas20Document extends OasDocument {
    public swagger : string;

    public host : string;

    public basePath : string;

    public schemes : Array<string>;

    public consumes : Array<string>;

    public produces : Array<string>;

    public definitions : Oas20Definitions;

    public parameters : Oas20ParameterDefinitions;

    public responses : Oas20ResponseDefinitions;

    public securityDefinitions : Oas20SecurityDefinitions;

    /**
     * @see io.apicurio.datamodels.core.models.Document#getDocumentType()
     * @return {DocumentType}
     */
    public getDocumentType() : DocumentType {
        return DocumentType.openapi2;
    }

    /**
     * @see io.apicurio.datamodels.openapi.models.OasDocument#createPaths()
     * @return {OasPaths}
     */
    public createPaths() : OasPaths {
        let rval : OasPaths = new Oas20Paths();
        rval._ownerDocument = this;
        rval._parent = this;
        return rval;
    }

    /**
     * Creates an OAS 2.0 Definitions object.
     * @return {Oas20Definitions}
     */
    public createDefinitions() : Oas20Definitions {
        let rval : Oas20Definitions = new Oas20Definitions();
        rval._ownerDocument = this;
        rval._parent = this;
        return rval;
    }

    /**
     * @see io.apicurio.datamodels.openapi.models.OasDocument#createSecurityRequirement()
     * @return {OasSecurityRequirement}
     */
    public createSecurityRequirement() : OasSecurityRequirement {
        let requirement : OasSecurityRequirement = new Oas20SecurityRequirement();
        requirement._ownerDocument = this.ownerDocument();
        requirement._parent = this;
        return requirement;
    }

    /**
     * @see io.apicurio.datamodels.core.models.Document#createInfo()
     * @return {Info}
     */
    public createInfo() : Info {
        let info : Info = new Oas20Info();
        info._ownerDocument = this.ownerDocument();
        info._parent = this;
        return info;
    }

    /**
     * @see io.apicurio.datamodels.core.models.Document#createTag()
     * @return {Tag}
     */
    public createTag() : Tag {
        let tag : Tag = new Oas20Tag();
        tag._ownerDocument = this.ownerDocument();
        tag._parent = this;
        return tag;
    }

    /**
     * @see io.apicurio.datamodels.core.models.Document#createExternalDocumentation()
     * @return {ExternalDocumentation}
     */
    public createExternalDocumentation() : ExternalDocumentation {
        let ed : ExternalDocumentation = new Oas20ExternalDocumentation();
        ed._ownerDocument = this.ownerDocument();
        ed._parent = this;
        return ed;
    }

    /**
     * Creates a security definitions.
     * @return {Oas20SecurityDefinitions}
     */
    public createSecurityDefinitions() : Oas20SecurityDefinitions {
        let sd : Oas20SecurityDefinitions = new Oas20SecurityDefinitions();
        sd._ownerDocument = this.ownerDocument();
        sd._parent = this;
        return sd;
    }

    /**
     * Creates the parameter definitions model.
     * @return {Oas20ParameterDefinitions}
     */
    public createParameterDefinitions() : Oas20ParameterDefinitions {
        let rval : Oas20ParameterDefinitions = new Oas20ParameterDefinitions();
        rval._ownerDocument = this;
        rval._parent = this;
        return rval;
    }

    /**
     * Creates the parameter definitions model.
     * @return {Oas20ResponseDefinitions}
     */
    public createResponseDefinitions() : Oas20ResponseDefinitions {
        let rval : Oas20ResponseDefinitions = new Oas20ResponseDefinitions();
        rval._ownerDocument = this;
        rval._parent = this;
        return rval;
    }

    constructor() {
        super();
        this.swagger = "2.0";
        if(this.host===undefined) this.host = null;
        if(this.basePath===undefined) this.basePath = null;
        if(this.schemes===undefined) this.schemes = null;
        if(this.consumes===undefined) this.consumes = null;
        if(this.produces===undefined) this.produces = null;
        if(this.definitions===undefined) this.definitions = null;
        if(this.parameters===undefined) this.parameters = null;
        if(this.responses===undefined) this.responses = null;
        if(this.securityDefinitions===undefined) this.securityDefinitions = null;
    }
}
Oas20Document["__class"] = "io.apicurio.datamodels.openapi.v2.models.Oas20Document";
Oas20Document["__interfaces"] = ["io.apicurio.datamodels.core.models.common.ISecurityRequirementParent","io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.common.IExternalDocumentationParent"];





import { Oas20ExternalDocumentation } from './Oas20ExternalDocumentation';


import { Oas20Tag } from './Oas20Tag';


import { Oas20Info } from './Oas20Info';


import { Oas20SecurityRequirement } from './Oas20SecurityRequirement';


import { Oas20Paths } from './Oas20Paths';


import { Oas20SecurityDefinitions } from './Oas20SecurityDefinitions';


import { Oas20ResponseDefinitions } from './Oas20ResponseDefinitions';


import { Oas20ParameterDefinitions } from './Oas20ParameterDefinitions';


import { Oas20Definitions } from './Oas20Definitions';

